export enum PromotionChallengeSocialEnum {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  LINE = 'LINE',
}
